import Vue from 'vue'
import VueRouter from 'vue-router'
import { GetUserRoutersApi } from '@/request/api'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'mainlayout',
        component: () => import(/* webpackChunkName: "mainlayout" */ '../views/layout/MainLayout.vue'),
        redirect: "/home",
        children: []
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '../views/login/Login.vue')
    },
    {
        path: '*',
        component: () => import(/* webpackChunkName: "404" */ '../views/404.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// 路由守卫
router.beforeEach(async (to, from, next) => {
    const token = localStorage.getItem('backend-authorization-token');
    if (to.path == "/login" && token) {
        next("/");
        return
    }
    if (to.path != "/login" && !token) {
        next("/login");
        return
    }

    if (token && store.state.userMenuData.menuData.length == 0) {
        let GetUserRoutersApiRes = await GetUserRoutersApi()
        console.log(GetUserRoutersApiRes);
        if (!GetUserRoutersApiRes) return;
        let newUserMenuData = [{ title: "首页", path: "/home", icon: "dashboard" },]
        let ret = GetUserRoutersApiRes.data.map(item => {
            if (item.children) {
                return {
                    title: item.title,
                    icon: item.icon,
                    path: item.path,
                    children: item.children.map(sitem => {
                        return {
                            title: sitem.title,
                            path: item.path + "/" + sitem.path
                        }
                    }),
                }
            } else {
                return {
                    title: item.title,
                    icon: item.icon,
                    path: item.path,
                }
            }

        })
        newUserMenuData = [...newUserMenuData, ...ret];
        console.log(newUserMenuData);
        // 更新到vuex  store.commit("文件夹名称/方法名",要传的参数)
        store.commit("userMenuData/changeMenuData", newUserMenuData)
        store.commit("userInfo/changeUserFen", GetUserRoutersApiRes.fen)
        store.commit("userInfo/changeUserIsAdmin", GetUserRoutersApiRes.is_admin)
        store.commit("userInfo/changeUserTerm", GetUserRoutersApiRes.term)
        store.commit("userInfo/changeMyName", GetUserRoutersApiRes.name)
        
        // 生成路由
        let newChildrenRoutes = [{
            path: "/home",
            meta: { titles: ["首页"] },
            component: () => import('../views/HomeView.vue')
        },
        {
            path: "/profile",
            meta: { titles: ["个人中心"] },
            component: () => import('../views/Profile.vue')
        }]

        GetUserRoutersApiRes.data.forEach(item => {
            let ret = item.children.map(sitem => {
                return {
                    path: item.path + "/" + sitem.path,
                    component: () => import(`../views${item.path}/${sitem.name}.vue`),
                    meta: {
                        titles: [item.title, sitem.title]
                    }
                }
            })

            newChildrenRoutes = [...newChildrenRoutes, ...ret]
        })

        console.log(newChildrenRoutes);

        // 把生成好的数组添加到mainlayout路由里面的children，作为子路由
        // router.addRoute(父路由名称，单个子路由对象)
        newChildrenRoutes.forEach(item => {
            router.addRoute("mainlayout", item);
        });

        next(to.path)
        return
    }
    next()
})

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
    return originalPush.call(this, location).catch(err => { })
};

export default router
